import AnalyticsApi, { IAnalyticsApi, IAnalyticsApiDependencies } from "./AnalyticsApi";
import AutocompleteApi, { IAutocompleteApi, IAutocompleteApiDependencies } from "./AutocompleteApi";
import ClassesApi, { IClassesApi, IClassesApiDependencies } from "./ClassesApi";
import { CourseAuthorApi, ICourseAuthorApi } from "./CourseAuthorApi";
import CoursesApi, { ICoursesApi, ICoursesApiDependencies } from "./CoursesApi";
import FontsApi from "./FontsApi";
import { IFontsApi } from "./FontsApi/types";
import GropusApi, { IGroupsApi } from "./GroupsApi";
import LoginApi, { ILoginApi, ILoginApiDependencies } from "./LoginApi";
import LogoutApi, { ILogoutApi, ILogoutApiDependencies } from "./LogoutApi";
import MediaApi, { IMediaApi } from "./MediaApi";
import MessagesApi, { IMessagesApi } from "./MessagesApi";
import {
  IOrganizationsApi,
  IOrganizationsApiDependencies,
  OrganizationsApi,
} from "./OrganizationsApi/organizations-api";
import PackagesApi, { IPackageApiDependencies, IPackagesApi } from "./PackagesApi";
import ResolveApi, { IResolveApi } from "./ResolveApi/resolve-api";
import { IResolveApiDependencies } from "./ResolveApi/resolve-api.types";
import ScormPackagesApi, { IScormPackagesApi, IScormPackagesApiDependencies } from "./ScormPackagesApi";
import StylesApi, { IStylesApi, IStylesApiDependencies } from "./StylesApi";
import UsersApi, { IUsersApi, IUsersApiDependencies } from "./UsersApi";

export type IApiDependencies = IAnalyticsApiDependencies &
  IAutocompleteApiDependencies &
  IClassesApiDependencies &
  ICoursesApiDependencies &
  ILoginApiDependencies &
  ILogoutApiDependencies &
  IOrganizationsApiDependencies &
  IPackageApiDependencies &
  IResolveApiDependencies &
  IScormPackagesApiDependencies &
  IStylesApiDependencies &
  IUsersApiDependencies;

export interface IApi {
  analytics: IAnalyticsApi;
  autocomplete: IAutocompleteApi;
  users: IUsersApi;
  classes: IClassesApi;
  courseAuthor: ICourseAuthorApi;
  courses: ICoursesApi;
  fonts: IFontsApi;
  login: ILoginApi;
  logout: ILogoutApi;
  organizations: IOrganizationsApi;
  packages: IPackagesApi;
  resolve: IResolveApi;
  scormPackages: IScormPackagesApi;
  styles: IStylesApi;
  groups: IGroupsApi;
  messages: IMessagesApi;
  media: IMediaApi;
}

export const createApi = (dependencies: IApiDependencies): IApi => {
  return {
    analytics: new AnalyticsApi(dependencies),
    autocomplete: new AutocompleteApi(dependencies),
    classes: new ClassesApi(dependencies),
    courseAuthor: new CourseAuthorApi(dependencies),
    courses: new CoursesApi(dependencies),
    fonts: new FontsApi(dependencies),
    groups: new GropusApi(dependencies),
    login: new LoginApi(dependencies),
    logout: new LogoutApi(dependencies),
    media: new MediaApi(dependencies),
    messages: new MessagesApi(dependencies),
    organizations: new OrganizationsApi(dependencies),
    packages: new PackagesApi(dependencies),
    resolve: new ResolveApi(dependencies),
    scormPackages: new ScormPackagesApi(dependencies),
    styles: new StylesApi(dependencies),
    users: new UsersApi(dependencies),
  };
};
